import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PolicyHero from './components/PolicyHero';
import PolicyContent from './components/PolicyContent';

const PolicyPage = () => {
  usePageMeta({
    title: '経営指針 | 株式会社MSK',
    ogTitle: '経営指針 | 株式会社MSK',
    description: '株式会社MSKの経営方針・社訓をご紹介いたします。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <PolicyHero />
        <PolicyContent />
      </main>
      <Footer />
    </div>
  );
};

export default PolicyPage;